import React from "react";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-red-navbar">
      <div className="container-fluid">
        <a className="navbar-brand" href="/landing">
          Home
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {/* ✅ LEFT SIDE MENU */}
          <ul className="navbar-nav me-auto">
            {/* ✅ Master Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="masterDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Master
              </a>

              <ul className="dropdown-menu" aria-labelledby="masterDropdown">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/robatmaster")}
                  >
                    Robot Master
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/feedbacktemplatemaster")}
                  >
                    Feedback Template Master
                  </button>
                </li>
              </ul>
            </li>
          </ul>

          {/* ✅ RIGHT SIDE LOGOUT BUTTON */}
          <div className="d-flex">
            <button
              className="btn btn-outline-light"
              onClick={() => navigate("/")}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
